import React, { useState, useEffect } from 'react';
import { publicAPI } from '../../services/api';
import './Nosotros.css';

const Nosotros = () => {
  const [heroStyle, setHeroStyle] = useState({ background: 'rgb(116, 70, 49)', color: 'white' });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchHeroImage = async () => {
      try {
        const response = await publicAPI.getHeroImage();
        if (response.data) {
          const { file_path, type } = response.data;
          if (type === 'image') {
             setHeroStyle({ background: `url(${file_path}) center/cover no-repeat`, color: 'rgb(116, 70, 49)' });
          } else if (type === 'color') {
             setHeroStyle({ background: file_path, color: 'white' });
          }
        } else { // Si no hay imagen activa, usar el color por defecto
          setHeroStyle({ background: 'rgb(116, 70, 49)', color: 'white' });
        }
      } catch (error) { console.error(error); }
      finally { setLoading(false); }
    };
    fetchHeroImage();
  }, []);

  if (loading) return <div className="loading">Cargando...</div>;

  return (
    <div className="nosotros" style={{ color: 'rgb(116, 70, 49)' }}>
      <div className="container">
        <section className="hero-section" style={heroStyle}>
          <h1>Nosotros</h1>
          <p className="subtitle">Conoce más sobre IMDI</p>
        </section>

        <section className="content-section">
          <div className="text-content">
            <h2>Nuestra Historia</h2>
            <p>
              IMDI es una empresa líder en la importación y distribución de repuestos
              automotrices de alta calidad. Con casi 50 años de experiencia en el mercado, nos
              hemos consolidado como una de las principales opciones para talleres
              mecánicos, distribuidores y particulares.
            </p>
            <p>
              Nuestro compromiso es ofrecer productos de las mejores marcas, garantizando
              calidad y durabilidad en cada pieza que distribuimos.
            </p>
          </div>

          <div className="features-grid">
            <div className="feature-card">
              <h3>Calidad</h3>
              <p>Respaldo de Marcas Líderes 
                Importamos y distribuimos exclusivamente las marcas con mayor prestigio y 
                certificaciones de calidad en el mercado global.</p>
            </div>
            <div className="feature-card">
              <h3>Experiencia</h3>
              <p>Trayectoria en el Sector
              Contamos con una sólida trayectoria en el mercado automotriz
               de casi 50 años, consolidándonos como un aliado estratégico
                para nuestros clientes.</p>
            </div>
            <div className="feature-card">
              <h3>Compromiso</h3>
              <p>Servicio de Excelencia
              Nos enfocamos en superar las expectativas de nuestros aliados comerciales 
              mediante un acompañamiento personalizado y postventa.</p>
            </div>
            <div className="feature-card">
              <h3>Innovación</h3>
              <p>Soluciones de Vanguardia	
              Implementamos las últimas tecnologías en nuestro catálogo y procesos logísticos
              para optimizar la cadena de suministro nacional.</p>
            </div>
            <div className="feature-card">
              <h3>Misión</h3>
              <p>Mantener nuestro reconocido prestigio en el mercado automotriz estando a la 
                vanguardia en desarrollo e innovación junto a proveedores Nacionales e 
                Internacionales, brindando a nuestros clientes total garantía de calidad y 
                disponibilidad de repuestos, minimizando niveles de precios y
                 maximizando la calidad de servicio a través de nuestro valioso talento humano.</p>
            </div>
            <div className="feature-card">
              <h3>Visión</h3>
              <p>Ser reconocidos como la organización líder a Nivel Nacional en la importación,
                distribución y comercialización al mayor de partes y repuestos automotrices, 
                cubriendo las exigencias del mercado, optimizando y mejorando continuamente los
                procesos hacia la plena satisfacción de las necesidades 
                de nuestros Clientes y Excelencia Organizacional.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Nosotros;
